"use client";
import React from "react";
import Header from "../component/Header.jsx";
import Footer from "../component/Footer.jsx";
import SkillBar from "../component/SkillBar.jsx";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  slidesBrand,
  slidesTeam,
  slidesTestimonail,
} from "../utilities/constant";
import { Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

const page = () => {
  return (
    <div className="main-wrapper">
      {/* <!-- Header Start  --> */}
      <Header />

      {/* <!-- Header End --> */}

      {/* <!-- Page Banner Start --> */}
      <div
        className="section page-banner-section page-banner-section-shape1-image"
        style={{ backgroundImage: "url(/images/aboutBanner.png)" }}
      >
        <div className="overlay"></div>
        <div className="shape-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="944px" height="894px">
            <defs>
              <linearGradient
                id="PSgrad_0"
                x1="88.295%"
                x2="0%"
                y1="0%"
                y2="46.947%"
              >
                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                <stop
                  offset="100%"
                  stopColor="rgb(113,65,177)"
                  stopOpacity="1"
                />
              </linearGradient>
            </defs>
            <path
              fillRule="evenodd"
              fill="rgb(43, 142, 254)"
              d="M39.612,410.76 L467.344,29.824 C516.51,-13.476 590.638,-9.93 633.938,39.613 L914.192,317.344 C957.492,366.50 953.109,440.637 904.402,483.938 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z"
            />
            <path
              fill="url(#PSgrad_0)"
              d="M39.612,410.76 L467.344,29.824 C516.51,-13.476 590.638,-9.93 633.938,39.613 L914.192,317.344 C957.492,366.50 953.109,440.637 904.402,483.938 L476.671,864.191 C427.964,907.492 353.376,903.109 310.76,854.402 L29.823,576.670 C-13.477,527.963 -9.94,453.376 39.612,410.76 Z"
            />
          </svg>
        </div>
        <div className="shape-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="726.5px"
            height="726.5px"
          >
            <path
              fillRule="evenodd"
              stroke="rgb(255, 255, 255)"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              opacity="0.302"
              fill="none"
              d="M28.14,285.269 L325.37,21.217 C358.860,-8.851 410.655,-5.808 440.723,28.14 L704.777,325.36 C734.846,358.859 731.802,410.654 697.979,440.722 L400.955,704.776 C367.132,734.844 315.338,731.802 285.269,697.978 L21.216,400.954 C-8.852,367.132 -5.808,315.337 28.14,285.269 Z"
            />
          </svg>
        </div>
        <div className="shape-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="515px" height="515px">
            <defs>
              <linearGradient
                id="PSgrad_0"
                x1="0%"
                x2="89.879%"
                y1="0%"
                y2="43.837%"
              >
                <stop offset="0%" stopColor="rgb(67,186,255)" stopOpacity="1" />
                <stop
                  offset="100%"
                  stopColor="rgb(113,65,177)"
                  stopOpacity="1"
                />
              </linearGradient>
            </defs>
            <path
              fillRule="evenodd"
              fill="rgb(43, 142, 254)"
              d="M19.529,202.280 L230.531,14.698 C254.559,-6.661 291.353,-4.498 312.714,19.528 L500.295,230.531 C521.656,254.558 519.493,291.353 495.466,312.713 L284.463,500.295 C260.436,521.655 223.641,519.492 202.281,495.465 L14.699,284.462 C-6.660,260.435 -4.498,223.640 19.529,202.280 Z"
            />
            <path
              fill="url(#PSgrad_0)"
              d="M19.529,202.280 L230.531,14.698 C254.559,-6.661 291.353,-4.498 312.714,19.528 L500.295,230.531 C521.656,254.558 519.493,291.353 495.466,312.713 L284.463,500.295 C260.436,521.655 223.641,519.492 202.281,495.465 L14.699,284.462 C-6.660,260.435 -4.498,223.640 19.529,202.280 Z"
            />
          </svg>
        </div>
        <div className="shape-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="972.5px"
            height="970.5px"
          >
            <path
              fillRule="evenodd"
              stroke="rgb(255, 255, 255)"
              strokeWidth="1px"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              fill="none"
              d="M38.245,381.102 L435.258,28.158 C480.467,-12.32 549.697,-7.964 589.888,37.244 L942.832,434.257 C983.23,479.466 978.955,548.697 933.746,588.888 L536.733,941.832 C491.524,982.23 422.293,977.955 382.103,932.745 L29.158,535.732 C-11.32,490.523 -6.963,421.293 38.245,381.102 Z"
            />
          </svg>
        </div>
        <div className="container">
          <div className="page-banner-wrap">
            <div className="row">
              <div className="col-lg-12">
                {/* <!-- Page Banner Content Start --> */}
                <div className="page-banner text-center">
                  <h2 className="title">About Us</h2>
                  <ul className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      About Us
                    </li>
                  </ul>
                </div>
                {/* <!-- Page Banner Content End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Page Banner End --> */}

      {/* <!-- About Start --> */}
      <div className="section techwix-about-section-07 section-padding">
        <div className="shape-1"></div>
        <div className="container">
          {/* <!-- About Wrapper Start --> */}
          <div className="about-wrap">
            <div className="row">
              <div className="col-lg-6">
                {/* <!-- About Image Wrap Start --> */}
                <div className="about-img-wrap">
                  <img
                    className="shape-1"
                    src="/images/shape/about-shape2.png"
                    alt=""
                  />
                  <div className="about-img">
                    <img src="/images/about-3.jpg" alt="" />
                  </div>
                  <div className="about-img about-img-2">
                    <img src="/images/about-4.jpg" alt="" />
                  </div>
                </div>
                {/* <!-- About Image Wrap End --> */}
              </div>
              <div className="col-lg-6">
                {/* <!-- About Content Wrap Start --> */}
                <div className="about-content-wrap">
                  <div className="section-title">
                    <h3 className="title">Who We Are</h3>
                    {/* <h2 className="sub-title"></h2> */}
                    <p className="text">
                      We are a Dubai-based IT startup at the forefront of
                      blockchain and cryptocurrency innovation. Since our
                      inception, we’ve dedicated ourselves to building
                      next-generation digital solutions that drive the
                      decentralized economy forward.
                    </p>
                    <p className="text">
                      Founded by a team of seasoned developers, crypto
                      enthusiasts, and visionary tech minds, our company has
                      successfully delivered numerous projects across
                      centralized exchanges, decentralized platforms, NFT
                      ecosystems, Web3 applications, and automated liquidity
                      solutions.
                    </p>
                  </div>
                  {/* <!-- About List Start --> */}
                  <div className="about-list-03">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="about-list-item-03">
                          <h3 className="title">Our Mission</h3>
                          <p>
                            To empower businesses and individuals by creating
                            secure, scalable, and future-ready blockchain
                            products that accelerate the global shift toward
                            decentralization and digital finance.
                          </p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="about-list-item-03">
                          <h3 className="title">Our Vision</h3>
                          <p>
                            To be a global leader in blockchain development,
                            helping clients harness the true power of Web3,
                            crypto trading, and tokenized assets.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- About List En/d --> */}
                </div>
                {/* <!-- About Content Wrap End --> */}
              </div>
            </div>
          </div>
          {/* <!-- About Wrapper End --> */}
        </div>
      </div>
      {/* <!-- About End --> */}

      {/* <!-- Counter Start --> */}
      <div className="section techwix-counter-section-03 techwix-counter-section-04">
        <div className="container">
          <div
            className="counter-wrap"
          >
            <div className="row">
              <div className="col-lg-3 col-sm-6">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter-02 text-center">
                  <span>354+</span>
                  <p>Completed Projects</p>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
              <div className="col-lg-3 col-sm-6">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter-02 text-center">
                  <span>119+</span>
                  <p>Robotic Automation</p>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
              <div className="col-lg-3 col-sm-6">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter-02 text-center">
                  <span>99%</span>
                  <p>Web Site Analyse</p>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
              <div className="col-lg-3 col-sm-6">
                {/* <!-- Single Counter Start --> */}
                <div className="single-counter-02 text-center">
                  <span>321+</span>
                  <p>Clients Supoort Done</p>
                </div>
                {/* <!-- Single Counter End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Counter End --> */}

      {/* <!-- Choose Us Start --> */}
      <div
        className="section techwix-choose-us-section section-padding"
        style={{ backgroundImage: "url(/images/bg/choose-us-bg3.jpg)" }}
      >
        <div className="container">
          {/* <!-- Choose Us Wrap Start --> */}
          <div className="choose-us-wrap">
            <div className="section-title text-center">
              {/* <h3 className="sub-title">REASON TO CHOOSE US</h3> */}
              <br></br>
              <h2 className="title">
                We provide truly prominent IT solutions.
              </h2>
            </div>
            <div className="choose-us-content-wrap">
              <div className="row">
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon9.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Infrustructure <br /> Technology
                        </Link>
                      </h3>
                      <p>
                        Built on advanced blockchain frameworks, our
                        infrastructure ensures seamless, secure, and scalable
                        tech solutions for Web3 evolution
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/counter-3.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Highly professional team members
                        </Link>
                      </h3>
                      <p>
                        Our skilled team combines extensive blockchain expertise
                        with hands-on experience to create innovative,
                        Cutting-edge digital solutions.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon10.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Security <br /> Management
                        </Link>
                      </h3>
                      <p>
                        Built-in end-to-end security guarantees all digital
                        transactions maintain trust, data integrity, and full
                        compliance at every phase.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon12.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Desktop <br /> Computing
                        </Link>
                      </h3>
                      <p>
                        Robust desktop computing solutions for blockchain
                        development, crypto trading, and decentralized app
                        system management.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/counter-1.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Scalable Blockchain <br /> Architecture
                        </Link>
                      </h3>
                      <p>
                        Optimized for performance and Scalability, our structure
                        delivers safe, Adaptable foundations for cutting-edge
                        Web3 apps and platforms.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/counter-2.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Ideas for high return investment
                        </Link>
                      </h3>
                      <p>
                        Maximize returns with secure blockchain ventures,
                        cutting-edge DeFi platforms, and forward-thinking crypto
                        asset strategies.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon21.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">
                          Fully high IT <br /> Managment
                        </Link>
                      </h3>
                      <p>
                        Comprehensive IT solutions guaranteeing peak efficiency,
                        robust protection, and flawless functionality for all
                        digital and blockchain systems.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  {/* <!-- Choose Us Item Start --> */}
                  <div className="choose-us-item-02">
                    <div className="choose-us-img">
                      <img src="/images/ser-icon22.png" alt="" />
                    </div>
                    <div className="choose-us-content">
                      <h3 className="title">
                        <Link href="/service">Data secure & Managment</Link>
                      </h3>
                      <p>
                        Cutting-edge data protection security and management
                        solutions built for assurance, reliability, performance,
                        and seamless digital integration.
                      </p>
                    </div>
                  </div>
                  {/* <!-- Choose Us Item End --> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Choose Us Wrap End --> */}
        </div>
      </div>
      {/* <!-- Choose Us End --> */}

      {/* <!-- Skill Start --> */}
      <div className="section techwix-skill-section-02 techwix-skill-section-03 section-padding">
        <div className="container">
          <div className="skill-wrap">
            <div className="row">
              <div className="col-lg-6">
                {/* <!-- Skill Left Start --> */}
                <div className="skill-left">
                  <div className="section-title">
                    <h2 className="title">
                      Preparing for your success, we provide truly prominent IT
                      solutions
                    </h2>
                  </div>
                  <div className="about-list">
                    <ul>
                      <li>
                        <span className="about-icon">
                          <i className="fas fa-check"></i>
                        </span>
                        <span className="about-text">
                          We always focus on technical excellence{" "}
                        </span>
                      </li>
                      <li>
                        <span className="about-icon">
                          <i className="fas fa-check"></i>
                        </span>
                        <span className="about-text">
                          {" "}
                          Wherever you’re going, we bring ideas and excitement{" "}
                        </span>
                      </li>
                      <li>
                        <span className="about-icon">
                          <i className="fas fa-check"></i>
                        </span>
                        <span className="about-text">
                          We’re consultants, guides, and partners for brands{" "}
                        </span>
                      </li>
                    </ul>
                  </div>
                  {/* <!-- About Author Info Wrap Start --> */}
                  <div className="about-author-info-wrap">
                    <div className="about-author">
                      <img src="/images/sign.png" alt="" />
                      <h3 className="name">Alen Morno sin</h3>
                      <span className="designation">CEO, Techmax</span>
                    </div>
                    <div className="about-info">
                      <p>Call to ask any question </p>
                      <h3 className="number">0123-456-7890</h3>
                    </div>
                  </div>
                  {/* <!-- About Author Info Wrap End --> */}
                </div>
                {/* <!-- Skill Left End --> */}
              </div>
              <div className="col-lg-6">
                {/* <!-- Skill Right Start --> */}
                <div className="skill-right">
                  <p className="text">
                    Empowering your success with cutting-edge IT solutions for a
                    brighter, efficient, and innovative future, built on trust,
                    expertise, and excellence — delivering reliability,
                    scalability, growth, and long-term digital transformation.
                  </p>
                  <div className="counter-bar">
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">IT Managment</span>
                      <SkillBar title={80} percentage={80} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Data Security</span>
                      <SkillBar title={95} percentage={95} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                    {/* <!-- Skill Item Start --> */}
                    <div className="skill-item">
                      <span className="title">Information Technology</span>
                      <SkillBar title={80} percentage={80} />
                    </div>
                    {/* <!-- Skill Item End --> */}
                  </div>
                </div>
                {/* <!-- Skill Right End --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Skill End --> */}

      {/* <!-- Team Start --> */}
      <div
        className="section techwix-team-section techwix-team-section-02 section-padding"
        style={{ backgroundImage: "url(/images/bg/team-bg1.jpg)" }}
      >
        <div className="container">
          {/* <!-- Team Wrap Start --> */}
          <div className="team-wrap">
            <div className="section-title text-center">
              <h3 className="sub-title">Our expert team </h3>
              <h2 className="title white"> We have world expert team</h2>
            </div>
            {/* <!-- Team Content Wrap Start --> */}

            <div className="team-content-wrap">
              <div className="swiper-container team-active">
                <Swiper
                  //   slidesPerView={4}
                  //   spaceBetween={0}
                  loop={true} // 👈 This enables infinite loop
                  pagination={{ dynamicMainBullets: true }}
                  modules={[Pagination]}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    991: {
                      slidesPerView: 4,
                    },
                    1401: {
                      slidesPerView: 4,
                    },
                  }}
                //   className="case-swiper"
                >
                  {slidesTeam.map((slide, i) => (
                    <SwiperSlide key={slide.id}>
                      {/* <div className="swiper-wrapper"> */}
                      <div className="swiper-slide">
                        {/* <!-- Single Team Start --> */}
                        <div className="single-team">
                          <div className="team-img">
                            <Link href="/team">
                              <img src={slide.image} alt={`Team ${i + 1}`} />
                            </Link>
                          </div>
                          <div className="team-content">
                            <h3 className="name">
                              <Link href="/team">
                                {slide.name} <br /> {slide.surname}
                              </Link>
                            </h3>
                            <span className="designation">
                              {slide.designation}
                            </span>
                            <div className="team-social">
                              <ul className="social">
                                <li>
                                  <Link href={"#"}>
                                    <i className="fab fa-facebook-f"></i>
                                  </Link>
                                </li>
                                <li>
                                  <Link href={"#"}>
                                    <i className="fab fa-twitter"></i>
                                  </Link>
                                </li>
                                <li>
                                  <Link href={"#"}>
                                    <i className="fab fa-dribbble"></i>
                                  </Link>
                                </li>
                                <li>
                                  <Link href={"#"}>
                                    <i className="fab fa-behance"></i>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        {/* <!-- Single Team End --> */}
                      </div>
                      {/* </div> */}
                    </SwiperSlide>
                  ))}
                </Swiper>

                {/* <!-- Add Pagination --> */}
                {/* <div className="swiper-pagination"></div> */}
              </div>
            </div>
            {/* <!-- Team Content Wrap End --> */}
          </div>
          {/* <!-- Team Wrap End --> */}
        </div>
      </div>
      {/* <!-- Team End --> */}

      {/* <!-- Testimonial Start  --> */}

      {/* <!-- Testimonial End  --> */}

      {/* <!-- Brand Logo Start --> */}
      <div className="section techwix-brand-section techwix-brand-section-03">
        <div className="container">
          {/* <!-- Brand Wrapper Start --> */}
          <div className="brand-wrapper text-center">
            {/* <!-- Brand Active Start --> */}
            <div className="brand-active">
              <div className="swiper-container">
                <Swiper
                  slidesPerView={5}
                  spaceBetween={30}
                  loop={true} // 👈 This enables infinite loop
                  pagination={{ dynamicMainBullets: true }}
                  //   modules={[Pagination]}
                  className="case-swiper"
                >
                  {slidesBrand.map((slide, i) => (
                    <SwiperSlide key={slide.id}>
                      <div className="swiper-slide single-brand">
                        <img src={slide.image} alt={`Brand ${i + 1}`} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            {/* <!-- Brand Active End --> */}
          </div>
          {/* <!-- Brand Wrapper End --> */}
        </div>
      </div>
      {/* <!-- Brand Logo End --> */}

      {/* <!-- Cta Start --> */}
      <div className="section techwix-cta-section-02 section-padding-02">
        <div className="container">
          {/* <!-- Cta Wrap Start --> */}
          <div
            className="cta-wrap"
          >
            <div className="row align-items-center">
              <div className="col-xl-9 col-lg-8">
                {/* <!-- Cta Content Start --> */}
                <div className="cta-content">
                  <div className="cta-icon">
                    <img src="/images/cta-icon2.png" alt="" />
                  </div>
                  <p>We’re Delivering the best customer Experience</p>
                </div>
                {/* <!-- Cta Content End --> */}
              </div>
              <div className="col-xl-3 col-lg-4">
                {/* <!-- Cta Button Start --> */}
                <div className="cta-btn">
                  <Link className="btn btn-white" href="#">
                    +41 920 090 505
                  </Link>
                </div>
                {/* <!-- Cta Button End --> */}
              </div>
            </div>
          </div>
          {/* <!-- Cta Wrap End --> */}
        </div>
      </div>
      {/* <!-- Cta End --> */}

      {/* <!-- Footer Section Start --> */}
      <Footer />
    </div>
  );
};

export default page;
